import { ReactNode } from 'react';
import Button from './core/Button';
import { IconWarningTriangle } from '@/icons';

type DataNotFoundProps =
  | {
      onClick?: never;
      description: ReactNode;
      buttonTitle?: never;
    }
  | {
      onClick: () => void;
      description: ReactNode;
      buttonTitle: ReactNode;
    };

export const DataNotFound = ({
  onClick,
  description,
  buttonTitle,
}: DataNotFoundProps) => {
  return (
    <div className="flex size-full flex-row items-center justify-between p-4">
      <div className="flex w-full flex-col items-center justify-center">
        <span className="mb-4 flex items-center text-text-800">
          <IconWarningTriangle className="mr-2 size-4" aria-hidden="true" />
          {description}
        </span>
        {buttonTitle && <Button onClick={onClick}>{buttonTitle}</Button>}
      </div>
    </div>
  );
};
